// extracted by mini-css-extract-plugin
module.exports = {"btn":"ContactBtn_btn__3rOTN","icon__group":"ContactBtn_icon__group__2rX7M","btn__donwload":"ContactBtn_btn__donwload__2iyLK","colorStyle":"ContactBtn_colorStyle__1lbZA"};